export default __webpack_public_path__ + "static/media/8.35ee8919.jpg";